function toCamelCase(str) {
  return str.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace("-", "").replace("_", "")
  );
}

export function deepCamelCaseKeys(obj) {
  if (Array.isArray(obj)) {
    return obj.map((v) => deepCamelCaseKeys(v));
  }

  if (typeof obj === "object" && obj !== null) {
    return Object.entries(obj).reduce(
      (a, [key, value]) => ({
        ...a,
        [toCamelCase(key)]: deepCamelCaseKeys(value),
      }),
      {}
    );
  }

  return obj;
}
